import { createAction, props } from '@ngrx/store';
import { type } from '@app/util/util';
import {
  Billing, BillingUser, BillingPayload,
  BillingVm, BillingResponse, FindBillingCities, BillingCitiesResponse, BillingCreateItem
} from '@billing/entities/billing.payload';

export const fetchBillingAction = createAction(type('[Billing-Booking/API] Fetch billing info'),
  props<{ payload: Billing }>());
export const fetchBillingSuccessAction = createAction(type('[Billing-Booking/API] Fetch billing info success'),
  props<{ response: BillingResponse }>());
export const fetchUserBillingsAction = createAction(type('[Billing-Booking/API] Fetch user billings'),
  props<{ payload: BillingUser }>());
export const fetchUserBillingsSuccessAction = createAction(type('[Billing-Booking/API] Fetch user billings success'),
  props<{ response: BillingResponse[] }>());
export const createBillingAction = createAction(type('[Billing-Booking/API] Create billing info'),
  props<{ payload: BillingCreateItem }>());
export const createBillingSuccessAction = createAction(type('[Billing-Booking/API] Create billing info success'),
  props<{ response: BillingPayload }>());
export const setBillingAction = createAction(type('[Billing-Booking/API] Set billing info'),
  props<{ payload: BillingVm }>());
export const setBillingSuccessAction = createAction(type('[Billing-Booking/API] Set billing info success'),
  props<{ response: BillingVm }>());
export const deleteBillingAction = createAction(type('[Billing-Booking/API] Delete billing info'),
  props<{ payload: Billing }>());
export const deleteBillingSuccessAction = createAction(type('[Billing-Booking/API] Delete billing info success'),
  props<{ response: Billing }>());
export const fetchBillingCitiesAction = createAction(type('[Billing-Booking/API] Fetch billing cities'),
  props<{ payload: FindBillingCities }>());
export const fetchBillingCitiesSuccessAction = createAction(type('[Billing-Booking/API] Fetch billing cities success'),
  props<{ response: BillingCitiesResponse }>());
export const fetchDefaultBillingAction = createAction(type('[Billing-Booking/API] Fetch default user billing'),
  props<{ payload: BillingUser }>());
export const fetchDefaultBillingSuccessAction = createAction(type('[Billing-Booking/API] Fetch default user billing success'),
  props<{ response: BillingResponse }>());
export const setDefaultBillingDataAction = createAction(type('[Billing-Booking/API] Set default billing data'),
  props<{ response: BillingResponse }>());
export const fetchCityByIpAction = createAction(type('[Billing-Booking/API] Fetch default city by IP'));
export const createBillingUIAction = createAction(type('[Billing-Booking/API] Create billing UI action'),
  props<{ payload: boolean }>());

export const resetBillingModuleAction = createAction(type('[Billing-Booking/UI] Reset billing module values action'));

